import type { Mailbox } from '@/types';

// Mirrors backend/src/mail/access-tier.js: only Full access erases mail for good.
// Unknown (mailbox list not loaded yet) shows the button; the server still refuses.
export function canErase(tier: Mailbox['accessTier'] | undefined): boolean {
  return (tier ?? 'full') === 'full';
}
